import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import style from './style.scss';
import { withTranslation } from 'react-i18next'
import { isNotNullish } from 'utils/nullish';
import { LoadingOutlined } from '@ant-design/icons';
import ListTagClose from 'svg/v2/newcs_dashboard_list_tag_close.svg';

/**
 * 标签项视图
 */
@withTranslation()
export default class TagItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  componentDidUpdate() {
    this.state.editing && this.input && this.input.focus();
  }

  get allowDeleteTag() {
    const { handleDelTag } = this.props;
    return isNotNullish(handleDelTag);
  }

  handleDelTag(event) {
    const { demoApp, disabled, handleDelTag, issueId, tag, path } = this.props;
    event.stopPropagation();
    if (demoApp || disabled || !handleDelTag) {
      return;
    }
    handleDelTag(issueId, tag.get ? tag.get('tagId') : tag.tagId, path);
  }

  handleChangeEditState(event) {
    event.stopPropagation();
    if (this.props.disabled || this.state.editing) return;
    this.setState({
      editing: true,
    });
  }

  handleAddTag() {
    const { demoApp, disabled, handleAddTag, issueId, path } = this.props;
    const { input } = this;
    const trimmedValue = (input.value || '').trim();
    if (!trimmedValue) {
      this.setState({
        editing: false,
      });
      input.value = '';
      return;
    }
    if (demoApp || disabled || !handleAddTag) {
      return;
    }
    handleAddTag(issueId, trimmedValue, path);
    input.value = '';
    this.setState({
      editing: false,
    });
  }

  handleKeyUp(event) {
    // 回车键按下，让input 进入blur态，进行提交判定
    if (parseInt(event.which) !== 13) {
      return;
    }
    this.input.blur();
  }

  handleChange() {
    const { input } = this;
    input.value.length > 100 && (input.value = input.value.slice(0, 100));
  }

  render() {
    const { tag, appId, pid, loading } = this.props;
    const { tagType, tagId, tagName } = tag.toJS ? tag.toJS() : tag;
    const classes = classnames(style.tag, {
      [style.deletable]: parseInt(tagType) === 0 && this.allowDeleteTag,
      [style.editable]: !tagId,
      [style.editing]: this.state.editing,
      [style.loading]: loading,
    });

    return (
      <div
        className={classes}
        onClick={!tagId ? ((event) => this.handleChangeEditState(event)) : undefined}>
        {!!tagName && tagName !== 'ADD_ISSUE_TAG'
          ? <Link
              to={`/crash-reporting/advanced-search/${appId}?pid=${pid}&start=0&tagList=${tagId}`}
              target="_blank"
              rel="noopener noreferrer"
            >{tagName}</Link>
          : <span>{loading ? <LoadingOutlined /> : this.props.t("BASEPROBLEM.addTag")}</span>}
        {!tagId
          && (
            <input
              type="text"
              ref={(target) => { this.input = target; }}
              onBlur={() => this.handleAddTag()}
              onKeyUp={(event) => this.handleKeyUp(event)}
              onChange={() => this.handleChange()} />
          )
        }
        {parseInt(tagType) === 0 && this.allowDeleteTag && (
          <div className={style.icon_close} onClick={(event) => this.handleDelTag(event)}>
            {loading ? <LoadingOutlined /> : <ListTagClose />}
          </div>
        )}
      </div>
    );
  }
}

TagItem.propTypes = {
  tag: PropTypes.object.isRequired,
  handleDelTag: PropTypes.func,
  handleAddTag: PropTypes.func.isRequired,
  issueId: PropTypes.string.isRequired,
  path: PropTypes.string,
  demoApp: PropTypes.bool,
  appId: PropTypes.any,
  pid: PropTypes.any,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};
